import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WarningDialogComponent } from 'src/app/shared/dialogs/warning-dialog/warning-dialog.component';
import { FileSave } from './model/file-uplaod.interface';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NameFileRegex } from 'src/app/core/model/constans';
import { FileUploadService } from 'src/app/pages/file-upload/service/file-upload.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { FilePresignUrlUploadService } from './service/file-upload-component.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-file-upload-component',
  templateUrl: './file-upload-component.component.html',
  styleUrls: ['./file-upload-component.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FileUploadComponentComponent,
      multi: true,
    },
  ],
})
export class FileUploadComponentComponent implements OnInit, ControlValueAccessor {
  @Input()
  labelText: string;

  @Input()
  oneFile: boolean;

  @Input()
  extensions: string[];

  @Input()
  isImg: boolean;

  @Input()
  maxSizeFile: number;

  @Input()
  documentId: number;

  @Input()
  ocrValidation: boolean;

  @Input()
  submitted: boolean;

  @Input()
  required: boolean;

  @Input()
  id: string;
  imageSrc: string;
  fileName: string;
  extensionsText: string;
  fileModel: any;
  isMobile: boolean;
  filesImg: FileSave[] = [];
  useCamera: boolean = false;
  presignUrl: string = '';
  private subscriptions: Subscription | undefined;

  onChange: (value: any) => void = () => {
    // Implementación de la función onChange
  };
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef = {} as ElementRef;

  constructor(
    private readonly dialog: MatDialog,
    private readonly cd: ChangeDetectorRef,
    private readonly servicePresignUrl: FilePresignUrlUploadService,
    private readonly deviceService: DeviceDetectorService,
    private readonly service: FileUploadService,
    private readonly spinner: NgxSpinnerService,
  ) {
    this.isImg = false;
    this.oneFile = false;
    this.labelText = '';
    this.extensions = [];
    this.submitted = false;
    this.required = false;
    this.maxSizeFile = 0;
    this.documentId = 0;
    this.id = '';
    this.fileName = '';
    this.extensionsText = '';
    this.imageSrc = '';
    this.ocrValidation = false;
    this.isMobile = this.deviceService.isMobile();
  }

  writeValue(obj: any): void {
    if (obj?.length > 0) {
      for (let file of obj) {
        this.filesImg.push(file);
      }
      this.cd.detectChanges();
    } else {
      this.filesImg = [];
      this.cd.detectChanges();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState?(isDisabled: boolean): void {}

  ngOnInit(): void {
    this.extensionsText = this.extensions.join(' - ');
  }

  ngOnDestroy() {
    this.subscriptions?.unsubscribe();
  }

  onFileDropped(event: any[]) {
    if (event) {
      let file: File = event[0];
      if (file) {
        const timestamp = new Date().toISOString();
        this.fileName = timestamp.replace(':', '').replace(':', '').replace('.', '') + '/' + file.name;
        this.subscriptions = this.servicePresignUrl
          .getPresignUrlUpload(this.fileName, file.type)
          .subscribe((res: string) => {
            this.presignUrl = res;
            this.readFile(file);
          });
      }
    }
  }

  clearFileInput() {
    this.fileInput.nativeElement.value = null;
  }

  async uploadFile(file: File, isOcr: boolean) {
    try {
      this.spinner.show().catch();
      await fetch(this.presignUrl, {
        method: 'PUT',
        headers: { 'Content-Type': file.type ?? 'multipart/form-data' },
        body: file,
      });
      this.spinner.hide().catch();
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async (e) => {
        this.imageSrc = reader.result as string;
        const img: {
          src: string;
          name: string;
          type: string;
          id: number;
          file?: File;
        } = {
          src: this.imageSrc,
          name: this.fileName,
          type: file.type,
          id: this.documentId,
        };
        if (isOcr) img.file = file;
        this.filesImg.push(img);
        this.onChange(this.filesImg);
      };
    } catch (error) {
      console.error('Hubo un error al cargar el archivo en el bucket');
    }
  }

  deleteImg(id: any) {
    event?.stopPropagation();
    const filesDeleted = this.filesImg.splice(id, 1);
    // Delete img del bucket fileDeleted[0] es el file
    this.subscriptions = this.servicePresignUrl.deleteFileBucket(filesDeleted[0].name).subscribe((deleted: any) => {
      if (deleted) console.log('Archivo eliminado');
      else console.error('No se pude eliminar el archivo');
    });
    this.onChange(this.filesImg);
  }

  async onFileSelected(event: any) {
    if (event?.target?.files) {
      let file: File = event.target.files[0];
      if (this.validateFile(file)) {
        const timestamp = new Date().toISOString();
        this.fileName = timestamp.replace(':', '').replace(':', '').replace('.', '') + '/' + file.name;
        this.subscriptions = this.servicePresignUrl
          .getPresignUrlUpload(this.fileName, file.type)
          .subscribe((res: string) => {
            this.presignUrl = res;
            this.readFile(file);
          });
      }
      this.clearFileInput();
    }
  }

  readFile(file: File) {
    document.getElementById('id')?.remove();
    if (this.ocrValidation) {
      this.uploadFile(file, true);
    } else {
      this.uploadFile(file, false);
    }
  }

  clickInput() {
    let input = document.getElementById(this.id);
    if (input) {
      input.click();
    }
  }

  openFileDialog() {
    this.clickInput();
  }

  openFileDialogOnKeyDown(event: KeyboardEvent) {
    this.openFileDialog();
  }

  validateFile(file: File): boolean {
    const isImage = file.type.startsWith('image/');
    if (!this.validateExtension(file)) {
      this.showWarning('O arquivo tem uma extensão inválida.');
      return false;
    }

    if (!this.validateFileSize(file)) {
      this.showWarning(`O arquivo deve ter menos de ${this.maxSizeFile}MB.`);
      return false;
    }

    if (!this.validateName(file)) {
      this.showWarning(`O nome do arquivo não é válido.`);
      return false;
    }

    return true;
  }

  validateExtension(file: File): boolean {
    return this.extensions.some((s) => {
      return file.type.includes(s.replace('.', ''));
    });
  }

  validateName(file: File): boolean {
    return NameFileRegex.test(file.name);
  }

  validateFileSize(file: File): boolean {
    const fileSize = this.maxSizeFile - 0.2;
    return file.size / 1024 / 1024 < fileSize;
  }

  showWarning(message: string) {
    this.dialog.open(WarningDialogComponent, {
      data: {
        title: 'Não foi possível anexar o arquivo.',
        message,
      },
    });
  }

  validateWarning() {
    if (this.required && this.submitted && this.filesImg.length == 0) {
      return true;
    }
    return false;
  }
}
